import { Callout, DirectionalHint, IconButton, IStackTokens, Stack } from "@fluentui/react";
import { useBoolean, useId } from "@fluentui/react-hooks";

export type LabelWithDescriptionProps = {
    label_description: string
    directional_hint?: DirectionalHint
    children: React.ReactNode
}

export const LabelWithDescription = (props: LabelWithDescriptionProps): JSX.Element => {
  const [isCalloutVisible, { toggle: toggleIsCalloutVisible }] = useBoolean(false);
  const descriptionId: string = useId('description');
  const iconButtonId: string = useId('iconButton');

  const stackTokens: IStackTokens = {
    childrenGap: 4,
    maxWidth: 300,
  };

  return (
    <>
      <Stack horizontal verticalAlign="center" tokens={stackTokens} style={{marginLeft: "0px", marginRight: "auto"}}>
        <span>{props.children}</span>
        <IconButton
          id={iconButtonId}
          iconProps={{iconName: "info"}}
          title="Info"
          ariaLabel="Info"
          onClick={toggleIsCalloutVisible}
          styles={{ root: { marginBottom: -3 } }}
        />
        {isCalloutVisible && (
          <Callout
            target={'#' + iconButtonId}
            setInitialFocus
            onDismiss={toggleIsCalloutVisible}
            ariaDescribedBy={descriptionId}
            role="alertdialog"
            isBeakVisible={true}
            directionalHint={props.directional_hint}
            gapSpace={0}
            calloutMaxHeight={200}
          >
            <Stack tokens={stackTokens} horizontalAlign="start" styles={{ root: { padding: 20 } }}>
              <span id={descriptionId}>{props.label_description}</span>
            </Stack>
          </Callout>
        )}
      </Stack>
    </>
  );
};
